exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AgencyCard-label-1YkJj{padding:10px 0}.AgencyCard-address-3zG_7{min-height:67px;padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}.AgencyCard-address-3zG_7>div{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
exports.locals = {
	"label": "AgencyCard-label-1YkJj",
	"address": "AgencyCard-address-3zG_7"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/company/components/AgencyCard.less
// module id = 1610
// module chunks = 0